import { Badge, Table } from 'react-bootstrap';

// fix_issue3.md #5 - owner policy badges. #6 - configurable specification sheet.
const POLICY_LABELS = {
  securityDeposit: 'Security deposit',
  cashOnDelivery: 'Cash on delivery',
  freeShipping: 'Free shipping',
  freeMaintenance: 'Free maintenance'
};

export function PolicyBadges({ policies }) {
  const active = Object.entries(policies || {}).filter(([, v]) => v);
  if (active.length === 0) return null;
  return (
    <div className="mb-3 d-flex flex-wrap gap-2">
      {active.map(([key]) => (
        <Badge key={key} bg="success" className="fw-normal">✓ {POLICY_LABELS[key] || key}</Badge>
      ))}
    </div>
  );
}

export function SpecificationsTable({ specifications }) {
  const rows = (specifications || []).filter((s) => s && (s.label || s.value));
  if (rows.length === 0) return null;
  return (
    <div className="mb-3">
      <h5>Specifications</h5>
      <Table size="sm" bordered className="mb-0" style={{ maxWidth: 480 }}>
        <tbody>
          {rows.map((s, i) => (
            <tr key={i}>
              <th className="text-muted fw-normal" style={{ width: '40%' }}>{s.label}</th>
              <td>{s.value}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
}
